<template>
  <div style="display: inline-block">
    <el-select :value="value" :collapse-tags="collapse_tags" :clearable="clearable" :disabled="disabled"
               :multiple="multiple" :placeholder="$t('select.shop')" filterable size="small"
               class="fix-collapse-tags" @change="m__on_change">
      <!-- todo: show all, not grouped -->
      <template v-if="is_mobile_device()">
        <el-option v-for="item in shopee_shop_list" :key="item._id" :value="item._id"
                   :label="`${item.username} ${item.name}`">
          <div>
            <table style="width:100%;">
              <tbody>
              <tr>
                <td style="width:40px;">
                  <img style="width:28px; height:28px; border-radius: 50vh;"
                       :src="logo_channel(item.channel)"
                       alt="image">
                </td>
                <td style="padding-left:10px;">
                  {{ item.username }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </el-option>
      </template>
      <!-- todo: grouped -->
      <template v-else>
        <el-option-group :label="$t('shop.added')">
          <el-option v-for="item in shopee_shop_list.filter(i => !i.is_sub_account)" :key="item._id"
                     :value="item._id" :label="`${item.username} ${item.name}`">
            <div>
              <table style="width:100%;">
                <tbody>
                <tr>
                  <td style="width:40px;">
                    <img style="width:28px; height:28px; border-radius: 50vh;"
                         :src="logo_channel(item.channel)"
                         alt="image">
                  </td>
                  <td style="padding-left:10px;">
                    {{ item.username }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </el-option>
        </el-option-group>
        <el-option-group :label="$t('shop.managed')">
          <el-option v-for="item in shopee_shop_list.filter(i => i.is_sub_account)" :key="item._id"
                     :value="item._id" :label="`${item.username} ${item.name}`">
            <div>
              <table style="width:100%;">
                <tbody>
                <tr>
                  <td style="width:40px;">
                    <img style="width:28px; height:28px; border-radius: 50vh;"
                         :src="logo_channel(item.channel)"
                         alt="image">
                  </td>
                  <td style="padding-left:10px;">
                    {{ item.username }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </el-option>
        </el-option-group>
      </template>
    </el-select>
  </div>
</template>


<script>
export default {
  name: 'select_shop',

  props: {
    value: {
      type: String,
      default: () => null
    },
    shopee_shop_list: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    collapse_tags: {
      type: Boolean,
      default: () => false
    }
  },

  methods: {
    m__on_change(value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shop_select.vue